import React from 'react';
import { heroCards } from '../data/content';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      {/* Decorative blobs */}
      <div className="hero__blob hero__blob--tr" aria-hidden="true" />
      <div className="hero__blob hero__blob--bl" aria-hidden="true" />

      {/* Left: text */}
      <div className="hero__text">
        <span className="hero__tag">Outsourcing Excellence · Cleaning with Care</span>
        <h1 className="hero__title">
          Professional Cleaning
          <em>You Can Trust</em>
        </h1>
        <p className="hero__sub">
          Fresh Wave Solutions Limited delivers reliable, detail-focused cleaning
          services for homes, businesses, and commercial spaces with integrity
          in every clean.
        </p>
        <div className="hero__actions">
          <a href="#contact" className="btn btn--primary">Get in Touch</a>
          <a href="#services" className="btn btn--outline">Our Services</a>
        </div>
      </div>

      {/* Right: feature cards */}
      <div className="hero__visual">
        {heroCards.map((card) => (
          <div className="hero-card" key={card.title}>
            <div className="hero-card__icon">{card.icon}</div>
            <div className="hero-card__text">
              <strong>{card.title}</strong>
              <span>{card.sub}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
